/* eslint-disable import/named */
/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';

import { Stores, Redux } from 'spwa-ui-library';
import { ThemeProvider } from '@material-ui/core/styles';
import Wrapper from './components/Multi-lang/Wrapper';
import App from './containers/App';
import kfc from './themes/kfc';
import * as serviceWorker from './serviceWorker';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import './index.scss';
import { appUpdatePwaGA } from 'spwa-ui-library/esm/utils/helperGA';

if (process.env.REACT_APP_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: [`${window.location.origin}/api`],
      }),
      new Sentry.Replay(),
    ],
    release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0, 
  });
}


let persistor = persistStore(Stores.default);
function removeCookiesByRegex(regexPattern) {
  const cookies = document.cookie.split(';');

  cookies.forEach((cookie) => {
    const cookieParts = cookie.split('=');
    const cookieName = cookieParts[0].trim();

    if (regexPattern.test(cookieName)) {
      document.cookie = `${cookieName}=; domain=.pizzahut.me;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
}
const regexPattern = /(^| )ab\.storage\..*|_scid_r|optimizelyEndUserId|_sctr|_tt_enable_cookie|_scid|_ttp|fs_uid/;
try {
  removeCookiesByRegex(regexPattern);
} catch (error) {
  console.log(error);
}
ReactDOM.render(
  <React.StrictMode>
    {/* <Redux.Provider> */}
    <Redux.Provider store={Stores.default}>
      <PersistGate loading={null} persistor={persistor}>
        <Wrapper>
          <ThemeProvider theme={kfc}>
            <App />
          </ThemeProvider>
        </Wrapper>
      </PersistGate>
      {/* </Redux.Provider> */}
    </Redux.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
const updateServiceWorker = (serviceWorkerRegistration) => {
  const registrationWaiting = serviceWorkerRegistration.waiting;
  if (registrationWaiting) {
    try {
      registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
      registrationWaiting.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          appUpdatePwaGA();
          window.location.reload();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
};
serviceWorker.register({
  onSuccess: () => {
    // alert('Page has been saved for offline use');
  },
  onUpdate: (reg) => {
    updateServiceWorker(reg);
  },
});
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
